import { authenticatedGet, authenticatedPost } from "../base/util/api";
import { showSuccess } from "../base/util/alerts";
import {
  digitalCartOverride,
  hardwareCartOverride,
  MODE_DIGITAL,
  MODE_HARDWARE,
} from "./shopReducer";
import { showError } from "../base/util/alerts";

export const SHOP_FETCH_CONFIG = "SHOP_CONFIG_FETCH";
export const SHOP_SET_CONFIG = "SHOP_CONFIG_SET";
export const SHOP_CART_NOF_CONTROLLERS_SET = "SHOP_CART_NOF_CONTROLLERS_SET";
export const SHOP_CART_NOF_SUBSCRIPTIONS_SET =
  "SHOP_CART_NOF_SUBSCRIPTIONS_SET";
export const SHOP_CART_SCALE_AMOUNT_SET = "SHOP_CART_SCALE_AMOUNT_SET";
export const SHOP_CART_SCALE_REMOVE = "SHOP_CART_SCALE_REMOVE";
export const SHOP_CART_ACCESSORY_AMOUNT_SET = "SHOP_CART_ACCESSORY_AMOUNT_SET";
export const SHOP_CART_ACCESSORY_REMOVE = "SHOP_CART_ACCESSORY_REMOVE";
export const SHOP_TOTAL_SET = "SHOP_TOTAL_SET";
export const SHOP_SET_CONFIG_YAML = "SHOP_SET_CONFIG_YAML";
export const SHOP_SET_CONFIG_ERROR = "SHOP_SET_CONFIG_ERROR";
export const SHOP_CART_SUBSCRIPTION_YEARS_SET =
  "SHOP_CART_SUBSCRIPTION_YEARS_SET";
export const SHOP_CART_PLATE_PICKUP_SET = "SHOP_CART_PLATE_PICKUP_SET";
export const SHOP_CART_FIELD_SET = "SHOP_CART_FIELD_SET";
export const SHOP_CART_ADDRESS_FIELD_SET = "SHOP_CART_ADDRESS_FIELD_SET";
export const SHOP_CART_ADDRESS_SET = "SHOP_CART_ADDRESS_SET";
export const SHOP_ORDERS_SET = "SHOP_ORDERS_SET";
export const SHOP_ORDERS_FETCH = "SHOP_ORDERS_FETCH";
export const SHOP_CART_RESET = "SHOP_CART_RESET";
export const SHOP_CART_COMMENT_SET = "SHOP_CART_COMMENT_SET";

export const fetchConfig =
  (id = null, filtered = true) =>
  (dispatch) =>
    fetchConfigNoCatch(
      id,
      filtered,
    )(dispatch).catch((msg) => showError(msg.message));

export const fetchConfigNoCatch =
  (id = null, filtered = true) =>
  (dispatch) => {
    dispatch({
      type: SHOP_FETCH_CONFIG,
    });
    return authenticatedGet(
      `shop/config${id ? `/${id}` : ""}?filtered=${filtered}`,
    ).then((config) =>
      dispatch({
        type: SHOP_SET_CONFIG,
        config,
      }),
    );
  };

export const setNofSubscriptions = (amount) => ({
  type: SHOP_CART_NOF_SUBSCRIPTIONS_SET,
  amount,
});
export const setNofControllers = (key, amount) => ({
  type: SHOP_CART_NOF_CONTROLLERS_SET,
  amount,
  key,
});
export const setSubscriptionYears = (years) => ({
  type: SHOP_CART_SUBSCRIPTION_YEARS_SET,
  years,
});
export const setAddressField = (field, value) => ({
  type: SHOP_CART_ADDRESS_FIELD_SET,
  field,
  value,
});
export const setCountry = (value) => setAddressField("country", value);
export const setAddress = (address) => ({
  type: SHOP_CART_ADDRESS_SET,
  address,
});
export const setCartField = (field, value) => ({
  type: SHOP_CART_FIELD_SET,
  field,
  value,
});
export const setScaleAmount = (scale, amount) => ({
  type: SHOP_CART_SCALE_AMOUNT_SET,
  scale,
  amount,
});
export const setComment = (comment) => ({
  type: SHOP_CART_COMMENT_SET,
  comment,
});

export const removeScale = (scale) => ({
  type: SHOP_CART_SCALE_REMOVE,
  scale,
});

export const setAccessoryAmount = (accessory, amount) => ({
  type: SHOP_CART_ACCESSORY_AMOUNT_SET,
  accessory,
  amount,
});

export const removeAccessory = (accessory) => ({
  type: SHOP_CART_ACCESSORY_REMOVE,
  accessory,
});

export const SHOP_CART_VALIDATE_FAIL = "SHOP_CART_VALIDATE_FAIL";
export const SHOP_CART_VALIDATE_FETCH = "SHOP_CART_VALIDATE_FETCH";
export const SHOP_CART_VALIDATE_SET = "SHOP_CART_VALIDATE_SET";
export const validateCart = (cart) => (dispatch) => {
  dispatch({ type: SHOP_CART_VALIDATE_FETCH });
  return authenticatedPost("shop/validate", cart)
    .then((value) =>
      dispatch({
        type: SHOP_CART_VALIDATE_SET,
        value,
      }),
    )
    .catch((e) => {
      dispatch({ type: SHOP_CART_VALIDATE_FAIL });
      throw e;
    });
};

export const SHOP_CART_ORDER_STOP = "SHOP_CART_ORDER_STOP";
export const SHOP_CART_ORDER_FAIL = "SHOP_CART_ORDER_FAIL";
export const SHOP_CART_ORDER_FETCH = "SHOP_CART_ORDER_FETCH";
export const SHOP_CART_ORDER_SET = "SHOP_CART_ORDER_SET";
export const submitOrder = (cart) => (dispatch) => {
  dispatch({ type: SHOP_CART_ORDER_FETCH });
  return authenticatedPost("shop/order", cart).catch((e) => {
    dispatch({ type: SHOP_CART_ORDER_FAIL });
    throw e;
  });
};

export const stopOrdering = () => ({
  type: SHOP_CART_ORDER_STOP,
});

export const setYamlConfig = (yamlConfig) => ({
  type: SHOP_SET_CONFIG_YAML,
  yamlConfig,
});

export const fetchYamlConfig =
  (version = null) =>
  (dispatch) => {
    const versionQuery = version ? `&version=${version}` : "";
    authenticatedGet("shop/configAdmin" + versionQuery)
      .then((msg) => dispatch(setYamlConfig(msg.message)))
      .catch((msg) => showError(msg.message));
  };

export const setConfigError = (error) => ({
  type: SHOP_SET_CONFIG_ERROR,
  error,
});

export const saveConfig = (config) => (dispatch) => {
  authenticatedPost("shop/config", { config })
    .then((msg) => {
      showSuccess(msg.message);
      dispatch(setConfigError(null));
    })
    .catch((err) => dispatch(setConfigError(err.message)));
};

export const setPlatePickup = (provider) => ({
  type: SHOP_CART_PLATE_PICKUP_SET,
  provider,
});

export const fetchOrders = () => (dispatch) => {
  dispatch({ type: SHOP_ORDERS_FETCH });
  return authenticatedGet("shop/orders")
    .then((orders) =>
      dispatch({
        type: SHOP_ORDERS_SET,
        orders,
      }),
    )
    .catch((msg) => showError(msg.message));
};

export const editOrder = (id, order) => (dispatch) => {
  return authenticatedPost(`shop/orders/${id}`, order)
    .then(() => dispatch(fetchOrders()))
    .catch((msg) => showError(msg.message));
};

export const cartReset = (mode, overrides = {}) => {
  let modeOverrides;
  if (mode === MODE_DIGITAL) {
    modeOverrides = digitalCartOverride;
  } else if (mode === MODE_HARDWARE) {
    modeOverrides = hardwareCartOverride;
  } else {
    throw new Error("Invalid mode " + mode);
  }
  return {
    type: SHOP_CART_RESET,
    overrides: {
      ...modeOverrides,
      ...overrides,
    },
  };
};

export const SHOP_ORDER_COMPLETED = "SHOP_ORDER_COMPLETED";
// NOT "SHOP_CART_…": the shop reducer routes that prefix to the cart
// sub-reducer, but completing an order writes lastOrder AND resets the cart.
export const orderCompleted = (orderkey, paymentMethod) => ({
  type: SHOP_ORDER_COMPLETED,
  orderkey,
  paymentMethod,
});

export const setMode = (mode) => setCartField("mode", mode);

export const resendOrderConfirmation = (orderId, sendTemplate) => (dispatch) =>
  authenticatedPost(`shop/orders/${orderId}/resendConfirmation`, {
    sendTemplate,
  })
    .then((msg) => showSuccess(msg.message))
    .catch((msg) => showError(msg.message));

export const activatePrepay = (orderId, sendTemplate) => (dispatch) =>
  authenticatedPost(`shop/orders/${orderId}/activatePrepay`, { sendTemplate })
    .then((msg) => showSuccess(msg.message))
    .catch((msg) => showError(msg.message));

export const releaseOrder =
  (orderId, sendTemplate, commissionerIndex) => (dispatch) =>
    authenticatedPost(
      `shop/orders/${orderId}/releaseOrder?commissionerIndex=${commissionerIndex}`,
      { sendTemplate },
    )
      .then((msg) => showSuccess(msg.message))
      .catch((msg) => showError(msg.message));

export const sendOffer = (orderId, sendTemplate) => (dispatch) =>
  authenticatedPost(`shop/orders/${orderId}/sendOffer`, { sendTemplate })
    .then((msg) => showSuccess(msg.message))
    .catch((msg) => showError(msg.message));
